import { User } from 'types/user';
import { UserActionsType, SET_USER } from './types';

export function setUser(user: User | null): UserActionsType {
  return {
    type: SET_USER,
    user,
  };
}
